import { Icon } from "@iconify/react/dist/iconify.js";
import { IconButton, Tooltip } from "@mui/material";

export default function InfoPopup({ content }) {
    return (
        <Tooltip 
            disableFocusListener 
            enterTouchDelay={100} 
            placement="bottom-end" 
            slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -10],
                        },
                    },
                    ],
                },
                }}
            title={ content }
        >
            <IconButton><Icon icon="material-symbols:info-outline" /></IconButton>
        </Tooltip>
    )
}